/*
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import urljoin from 'url-join';

import { windowPropertySSR } from '../utils';

const config = {
  domain: process.env.VITE_APP_MAP_AUTH0_DOMAIN,
  clientId: process.env.VITE_APP_MAP_AUTH0_CLIENT_ID,
  redirectUri: urljoin(
    windowPropertySSR('location.origin', '/'),
    process.env.VITE_APP_MAP_BASE_URL || '/'
  ),
  audience: process.env.VITE_APP_MAP_AUTH0_AUDIENCE,
  namespace: process.env.VITE_APP_MAP_AUTH0_NAMESPACE,
};

export default { config };
